export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10632.3f7936a4.jpg";